import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { mixpanel, constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Offers from 'compositions/Offers/Offers'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './PrepaidCardWithSubscriptionPlansModal.scss'


class PrepaidCardWithSubscriptionPlansModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      onChoose: PropTypes.func,
    }),
    billingPeriod: PropTypes.number,
  }

  static defaultProps = {
    name: constants.modals.prepaidCard.PrepaidCardWithSubscriptionPlans,
    data: {},
    billingPeriod: 0,
  }

  state = {
    plans: [],
  }

  componentDidMount() {
    const { billingPeriod: requiredBillingPeriod } = this.props

    mixpanel.track(constants.analyticsEvents.prepaidCardUpgradePopup)

    actions.models.subscription.fetchPlansSizes({ productsPerPeriod: 1 })
      .then((plansSizes) => {
        this.setState({
          plans: plansSizes.filter(({ billingPeriod }) => (
            billingPeriod > 3
            && billingPeriod > requiredBillingPeriod
          )),
        })
      })
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
    actions.misc.cookies.setSessionItem(constants.cookieNames.isPrepaidCardWithSubscriptionPlansModalHidden, true)
  }

  handleChoose = ({ planName }) => {
    const { data: { onChoose } } = this.props

    if (typeof onChoose === 'function') {
      onChoose(planName)
    }

    this.close()
  }

  render() {
    const { plans } = this.state
    const { name } = this.props

    const best = plans.length > 1 ? 6 : 12

    return (
      <Modal
        name={name}
        title={messages.title}
        onClose={this.close}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} />
        <Offers
          className={s.offers}
          itemClassName={s.offersItem}
          bestSize={best}
          items={plans}
          onChoose={this.handleChoose}
        />
      </Modal>
    )
  }
}


export default connect({
  billingPeriod: 'models.subscription.currPlan.billingPeriod',
  nextShippingDate: 'models.subscription.nextShippingDate',
})(PrepaidCardWithSubscriptionPlansModal)
